const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';

const jsonHeaders = { 'Content-Type': 'application/json' };

const handleResponse = async (response, fallbackMsg) => {
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.message || fallbackMsg);
  }
  return response.json();
};

// ─── SCHEDULE TYPES (Tipos de Horario) ──────────────────────────────

export const getScheduleTypes = async (laundryCenterId) => {
  const res = await fetch(
    `${API_URL}/schedule-management/schedule-types?laundryCenterId=${laundryCenterId}`,
  );
  return handleResponse(res, 'Error al obtener tipos de horario');
};

export const createScheduleType = async (data) => {
  const res = await fetch(`${API_URL}/schedule-management/schedule-types`, {
    method: 'POST',
    headers: jsonHeaders,
    body: JSON.stringify(data),
  });
  return handleResponse(res, 'Error al crear tipo de horario');
};

export const updateScheduleType = async (id, data) => {
  const res = await fetch(
    `${API_URL}/schedule-management/schedule-types/${id}`,
    {
      method: 'PUT',
      headers: jsonHeaders,
      body: JSON.stringify(data),
    },
  );
  return handleResponse(res, 'Error al actualizar tipo de horario');
};

export const deleteScheduleType = async (id) => {
  const res = await fetch(
    `${API_URL}/schedule-management/schedule-types/${id}`,
    { method: 'DELETE' },
  );
  return handleResponse(res, 'Error al eliminar tipo de horario');
};

// ─── SHIFT ROLES (Roles) ───────────────────────────────────────────

export const getShiftRoles = async (laundryCenterId) => {
  const res = await fetch(
    `${API_URL}/schedule-management/shift-roles?laundryCenterId=${laundryCenterId}`,
  );
  return handleResponse(res, 'Error al obtener roles');
};

export const createShiftRole = async (data) => {
  const res = await fetch(`${API_URL}/schedule-management/shift-roles`, {
    method: 'POST',
    headers: jsonHeaders,
    body: JSON.stringify(data),
  });
  return handleResponse(res, 'Error al crear rol');
};

export const updateShiftRole = async (id, data) => {
  const res = await fetch(
    `${API_URL}/schedule-management/shift-roles/${id}`,
    {
      method: 'PUT',
      headers: jsonHeaders,
      body: JSON.stringify(data),
    },
  );
  return handleResponse(res, 'Error al actualizar rol');
};

export const deleteShiftRole = async (id) => {
  const res = await fetch(
    `${API_URL}/schedule-management/shift-roles/${id}`,
    { method: 'DELETE' },
  );
  return handleResponse(res, 'Error al eliminar rol');
};

// ─── WEEKLY ASSIGNMENTS (Asignaciones) ──────────────────────────────

export const getWeeklyAssignments = async (laundryCenterId, weekStart) => {
  const res = await fetch(
    `${API_URL}/schedule-management/assignments?laundryCenterId=${laundryCenterId}&weekStart=${weekStart}`,
  );
  return handleResponse(res, 'Error al obtener asignaciones');
};

export const createAssignments = async (data) => {
  const res = await fetch(`${API_URL}/schedule-management/assignments`, {
    method: 'POST',
    headers: jsonHeaders,
    body: JSON.stringify(data),
  });
  return handleResponse(res, 'Error al crear asignaciones');
};

export const updateAssignment = async (id, data) => {
  const res = await fetch(
    `${API_URL}/schedule-management/assignments/${id}`,
    {
      method: 'PUT',
      headers: jsonHeaders,
      body: JSON.stringify(data),
    },
  );
  return handleResponse(res, 'Error al actualizar asignación');
};

export const getEmployeeAssignments = async (laundryCenterId, weekStart, { cedula, employeeId } = {}) => {
  const params = new URLSearchParams({ laundryCenterId, weekStart });
  if (employeeId) params.append('employeeId', employeeId);
  else if (cedula) params.append('cedula', cedula);
  const res = await fetch(`${API_URL}/schedule-management/assignments/employee?${params}`);
  return handleResponse(res, 'Error al obtener asignaciones del empleado');
};

export const deleteAssignment = async (id) => {
  const res = await fetch(
    `${API_URL}/schedule-management/assignments/${id}`,
    { method: 'DELETE' },
  );
  return handleResponse(res, 'Error al eliminar asignación');
};

export const deleteAllAssignmentsForWeek = async (
  laundryCenterId,
  weekStart,
) => {
  const res = await fetch(
    `${API_URL}/schedule-management/assignments?laundryCenterId=${laundryCenterId}&weekStart=${weekStart}`,
    { method: 'DELETE' },
  );
  return handleResponse(res, 'Error al eliminar asignaciones de la semana');
};
